'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeNotificationGroup = exports.getNotificationGroups = exports.setNotificationGroups = exports.getUserNotificationGroups = exports.setUserNotificationGroups = exports.fetchNotifications = exports.deleteNotification = exports.markUserNotifications = exports.deleteUserNotifications = exports.deleteUserNotification = exports.getUserNotifications = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _callApi = require('./callApi');

var _callApi2 = _interopRequireDefault(_callApi);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getUserNotifications = exports.getUserNotifications = function getUserNotifications(f) {
  return (0, _callApi2.default)('GET', '/user-notifications', null, 'application/json');
};
var deleteUserNotification = exports.deleteUserNotification = function deleteUserNotification(id) {
  return (0, _callApi2.default)('DELETE', '/user-notification/' + id, null, 'application/json');
};
var deleteUserNotifications = exports.deleteUserNotifications = function deleteUserNotifications(ids) {
  return (0, _callApi2.default)('DELETE', '/user-notifications', { ids: ids }, 'application/json');
};
var markUserNotifications = exports.markUserNotifications = function markUserNotifications(ids) {
  return (0, _callApi2.default)('POST', '/user-notifications/mark', { ids: ids }, 'application/json');
};
var deleteNotification = exports.deleteNotification = function deleteNotification(id) {
  return (0, _callApi2.default)('DELETE', '/notification', { id: id }, 'application/json');
};
var fetchNotifications = exports.fetchNotifications = function fetchNotifications(options) {
  return (0, _callApi2.default)('POST', '/notifications', _extends({}, options), 'application/json');
};
var setUserNotificationGroups = exports.setUserNotificationGroups = function setUserNotificationGroups(groups) {
  return (0, _callApi2.default)('POST', '/user-notification/groups', { groups: groups }, 'application/json');
};
var getUserNotificationGroups = exports.getUserNotificationGroups = function getUserNotificationGroups(f) {
  return (0, _callApi2.default)('GET', '/user-notification/groups', null, 'application/json');
};
var setNotificationGroups = exports.setNotificationGroups = function setNotificationGroups(groups) {
  return (0, _callApi2.default)('POST', '/notification/groups', { groups: groups }, 'application/json');
};
var getNotificationGroups = exports.getNotificationGroups = function getNotificationGroups(f) {
  return (0, _callApi2.default)('GET', '/notification/groups', null, 'application/json');
};
var removeNotificationGroup = exports.removeNotificationGroup = function removeNotificationGroup(group) {
  return (0, _callApi2.default)('DELETE', '/notification/group', { group: group }, 'application/json');
};


//////////////////
// WEBPACK FOOTER
// ./~/@hailtrace/client-api/dist/legacy/notifications.js
// module id = 737
// module chunks = 0